import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

/**
 * オンラインスピーキングSSO情報取得
 */
import { ApiTaLi060 } from '~/endpoints/ApiTaLi060'

// State types
export interface StateOnlineSpeakingSSO {
  url: string
  ssoKey: string
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}
export const getEmptyStateOnlineSpeakingSSO = (): StateOnlineSpeakingSSO => ({
  url: '',
  ssoKey: '',
  statusCode: 0,
  error: null,
})

export interface ActionParamsOnlineSpeakingSSO {
  courseId: string // コースID
  previousMonthCount: number // 契約開始月の何ヶ月前から有効とするか
  overDayCount: number // 契約完了月の何日後まで有効とするか
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/OnlineSpeakingSSO',
})
export default class OnlineSpeakingSSO extends VuexModule {
  // States
  private state_: StateOnlineSpeakingSSO = getEmptyStateOnlineSpeakingSSO()

  // Getters

  get result(): StateOnlineSpeakingSSO {
    return this.state_
  }

  get address(): string {
    if (this.state_.error !== null || !this.state_.url) {
      return ''
    }
    return this.state_.url + '?key=' + this.state_.ssoKey
  }

  // Mutations

  @Mutation
  updateStateOnlineSpeakingSSO(value: StateOnlineSpeakingSSO) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateStateOnlineSpeakingSSO'

  // Actions

  @Action
  clear() {
    this.context.commit(OnlineSpeakingSSO.MUTATION_NAME_UPDATE_STATE, getEmptyStateOnlineSpeakingSSO())
  }

  @Action
  async getOnlineSpeakingSSO(param: ActionParamsOnlineSpeakingSSO) {
    logger.trace('in: getOnlineSpeakingSSO')
    const api = new ApiTaLi060.Api()

    // API
    const result = await api.get<StateOnlineSpeakingSSO | null>(
      {
        query: {
          courseId: param.courseId,
          previousMonthCount: param.previousMonthCount,
          overDayCount: param.overDayCount,
        },
      },
      // Success
      (data, status) => {
        return {
          url: data.url,
          ssoKey: data.ssoKey,
          statusCode: status,
          error: null,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return {
          url: '',
          ssoKey: '',
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitdata: StateOnlineSpeakingSSO = getEmptyStateOnlineSpeakingSSO()
    if (result) {
      commitdata.statusCode = result.statusCode
      commitdata.error = result.error
      commitdata.url = result.url
      commitdata.ssoKey = result.ssoKey
    }
    this.context.commit(OnlineSpeakingSSO.MUTATION_NAME_UPDATE_STATE, commitdata)
  }
}
